import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-overwrite-modal',
    template: `
    <div class="modal-header">
      <h4 class="modal-title" i8n>Il file già esiste</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <p i18n>Il file "{{ file.name }}" è già presente per questo contesto. Vuoi sovrascriverlo?</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="confirmOverwrite()" i18n>Sovrascrivi</button>
      <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()" i18n>Annulla</button>
    </div>
  `,
})
export class ConfirmOverwriteModalComponent {
  @Input() file!: File;

  constructor(public activeModal: NgbActiveModal) {}

  confirmOverwrite() {
    this.activeModal.close(true); // Return true on overwrite
  }
}
